export default __webpack_public_path__ + "eded262c37213e411e07934ace260e15.gif";